import { KendoFinancialDrawdownChart } from "src/main";

import { ConnectedInformationButton } from "src/main";
import s from "./DailyDrawdownWidget.module.scss";
import { DrawdownChartLegend } from "src/components/__pageComponents/RiskPage/DrawdownChartLegend";
import {
  useGlobalCurrency,
  useHistoricVolatility,
  useReportBespoke,
} from "@iliotech/data-wire";
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";
import moment from "moment";
import { ReportWidgetProps } from "../../ReportWidgetProps";

export const DailyDrawdownWidget = observer(
  ({ height, width, periodContext }: ReportWidgetProps) => {
    const store = useReportBespoke();
    const { generating } = store;
    const { portfolioId } = useParams<{ portfolioId: string }>();
    const volatilityResponse = useHistoricVolatility(
      portfolioId!,
      periodContext.periodForRequest,
      "Daily"
    );
    const periodString = periodContext.periodString;
    const categoryFormatter = false
      ? (val: Date) => moment(val).format(`MMMM 'YY`)
      : (val: Date) => moment(val).format(`DD MMM 'YY`);
    const { currencyFormatter } = useGlobalCurrency();
    const drawdownData = volatilityResponse?.data?.data?.drawdown;

    return (
      <div>
        <h3 className={"element-title"}>
          {"Daily Performance Index and Drawdown"}
        </h3>
        <p style={{ marginBottom: 10 }} className={"period-string"}>
          {periodString}
        </p>

        <DrawdownChartLegend isPdfExport={generating} t={(v: string) => v} />
        <KendoFinancialDrawdownChart
          isPdfExport={generating}
          controls={{ expanded: false }}
          categoryFormatter={categoryFormatter}
          modifiers={{
            colors: { indexPerformanceColor: "var(--portfolio-color)" },
            lines: { indexLineThickness: 2, watermarkLineThickness: 2 },
            markers: {
              // watermarkMarker: {type: "circle", visible: true, }
            },
          }}
          drawdownData={drawdownData}
          t={(v: string) => v}
          nameHidden={true}
          height={height || 500}
          width={width}
          truncateDates={false}
          currencyFormatter={currencyFormatter}
          name={"Daily Performance Index and Drawdown"}
        />
      </div>
    );
  }
);
